import { createSvg } from '../createSvg';

const Location = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M11.9999 13.43C13.723 13.43 15.1199 12.0331 15.1199 10.31C15.1199 8.58687 13.723 7.19 11.9999 7.19C10.2768 7.19 8.87988 8.58687
                 8.87988 10.31C8.87988 12.0331 10.2768 13.43 11.9999 13.43Z'
                    strokeWidth={strokeWidth}
                />
                <path
                    d='M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995
                 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z'
                    strokeWidth={strokeWidth}
                />
            </g>
        </>
    );
};

export default createSvg(
    Location,
    'location',
);
